<clx-data-grid
    [data]="source"
    [showFilter]="false"
    [showSearchPanel]="false"
    [showGroupPanel]="false"
    [showColumnChooser]="false"
    [selection]="{ mode : 'none' }"
    [remoteOperations]="remoteOperations"
    [showHeaderFilter]="false"
    [version]="1"
    [id]="id"
    [attr.test-id]="testId"
>

    <clx-grid-column
        dataField="TimeSubmitted"
        dataType="string"
        i18n-caption="@@history.list.column.caption.sent"
        caption="Sent"
        sortOrder="desc"
        sortIndex="1"
        [width]="160"
    >
        <ng-template let-data="item">
            <span
                [class.error]="!data.data.IsSuccess"
                [class.success]="data.data.IsSuccess"
                [attr.test-id]="testId + '.row.' + data.rowIndex + '.time-submitted'"
                attr.title="{{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}"
            >{{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}</span>
        </ng-template>
    </clx-grid-column>

    <clx-grid-column
        dataField="Payload"
        dataType="string"
        i18n-caption="@@history.list.column.caption.payload"
        caption="Payload"
        [allowSorting]="false"
    >
        <ng-template let-data="item">
            <span class="pre-wrapped"
                [class.error]="!data.data.IsSuccess"
                [class.success]="data.data.IsSuccess"
                [attr.test-id]="testId + '.row.' + data.rowIndex + '.payload'"
                hmi-icons="{{data.value | formatNumericValue: data.data.CommandedNumericValue: data.data.CommandedValueRepresentation: false | async}}"
                [innerHTML]="data.value | formatNumericValue: data.data.CommandedNumericValue: data.data.CommandedValueRepresentation | async"
            ></span>
        </ng-template>
    </clx-grid-column>

    <clx-grid-column
        dataField="Result"
        dataType="string"
        i18n-caption="@@history.list.column.caption.result"
        caption="Result"
        [allowSorting]="false"
        [width]="200"
    >
        <ng-template let-data="item">
            <span
                [class.error]="!data.data.IsSuccess"
                [class.success]="data.data.IsSuccess"
                [attr.test-id]="testId + '.row.' + data.rowIndex + '.result'"
                attr.title="{{data.value}}"
            >{{data.value}}</span>
        </ng-template>
    </clx-grid-column>

</clx-data-grid>